import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import { getVehicleCount } from "../actions/getVehicleCountAction";

const initialState = {
    Object:null,
    loading : 'idle',
    hasError: false,
    errorMessage: ''
}
const vehicleCountSlice = createSlice({
    name: 'vehicleCount',
    initialState,
    reducers: {
         resetState: () => {
            return initialState;
        }

    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => {
            return initialState;
        })
            .addCase(getVehicleCount.pending, (state) => {
                state.loading = 'pending';
                state.hasError = false
            })
            .addCase(getVehicleCount.fulfilled, (state, action) => {
                state.loading = 'succeeded';
                state.hasError = false;
                state.Object = action.payload ;
                state.errorMessage = ""


            })
            .addCase(getVehicleCount.rejected, (state, action) => {
                state.loading = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload
            })
    }
});
export const { deleteFileById , resetState } = vehicleCountSlice.actions;

export default vehicleCountSlice.reducer;